
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/potwierdz",
      function () {
        return require("private-next-pages/potwierdz/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/potwierdz"])
      });
    }
  